import script from "./tip.vue?vue&type=script&setup=true&lang=ts"
export * from "./tip.vue?vue&type=script&setup=true&lang=ts"

import "./tip.vue?vue&type=style&index=0&id=4e8727e9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e8727e9"]])

export default __exports__